import _ from 'lodash';

import {
  buildCanvas,
  buildCanvasCarousel,
  buildCanvasVideo,
  buildCanvasPhoto
} from './CanvasCreator';

export const formatCanvasToLaunch = (canvas) => {
  const canvasObj = canvas.canvas[0];
  const formattedCanvas = [canvasObj];
  formattedCanvas[0].enableSwipe = canvasObj.enable_swipe;
  delete formattedCanvas[0].enable_swipe;
  const canvasElements = [];

  canvas.canvasPhotos.forEach((canvasPhoto) => {
    canvasElements.push({
      id: canvasPhoto.id,
      type: 'Photo',
      radioFit: canvasPhoto.option,
      name: canvasPhoto.name,
      url: canvasPhoto.image_url,
      imageTargetUrl: canvasPhoto.target_url,
      canvasId: canvasPhoto.canvas_id,
      order: canvasPhoto.order
    });
  });

  canvas.canvasVideos.forEach((canvasVideo) => {
    canvasElements.push({
      id: canvasVideo.id,
      type: 'Video',
      radioFitVideo: canvasVideo.option,
      name: canvasVideo.name,
      url: canvasVideo.video_url,
      canvasId: canvasVideo.canvas_id,
      order: canvasVideo.order
    });
  });

  canvas.canvasCarousels.forEach((canvasCarousel) => {
    const canvasCarouselsCards = canvas.canvasCarouselCards.filter(
      (card) => card.carousel_id === canvasCarousel.id
    );

    const cards = canvasCarouselsCards.map((card) => ({
      id: card.id,
      cardName: card.name,
      cardImageUrl: card.image_url,
      cardTargetUrl: card.target_url,
      carouselId: card.carousel_id
    }));

    canvasElements.push({
      id: canvasCarousel.id,
      type: 'Carousel',
      name: canvasCarousel.name,
      radioFitCarousel: canvasCarousel.option,
      cards,
      canvasId: canvasCarousel.canvas_id,
      order: canvasCarousel.order
    });
  });

  formattedCanvas.canvasElements = canvasElements;

  return formattedCanvas;
};

export const getCanvasData = (id, canvases) => {
  const canvasElements = [];

  const canvas = canvases.canvases.list.filter(
    (canvasItem) => canvasItem.id === id
  );

  const canvasPhotos = canvases.canvasPhoto.list.filter(
    (photo) => photo.canvasId === id
  );

  canvasPhotos.forEach((canvasPhoto) => {
    canvasElements.push({
      id: canvasPhoto.id,
      type: 'Photo',
      radioFit: canvasPhoto.option,
      name: canvasPhoto.name,
      url: canvasPhoto.imageUrl,
      imageTargetUrl: canvasPhoto.targetUrl,
      canvasId: canvasPhoto.canvasId,
      order: canvasPhoto.order
    });
  });

  const canvasVideos = canvases.canvasVideo.list.filter(
    (video) => video.canvasId === id
  );

  canvasVideos.forEach((canvasVideo) => {
    canvasElements.push({
      id: canvasVideo.id,
      type: 'Video',
      radioFitVideo: canvasVideo.option,
      name: canvasVideo.name,
      url: canvasVideo.videoUrl,
      canvasId: canvasVideo.canvasId,
      order: canvasVideo.order
    });
  });

  const canvasCarousels = canvases.canvasCarousel.list.filter(
    (carousel) => carousel.canvasId === id
  );

  canvasCarousels.forEach((canvasCarousel) => {
    const canvasCarouselsCards = canvases.canvasCarouselCard.list.filter(
      (card) => card.carouselId === canvasCarousel.id
    );

    const cards = canvasCarouselsCards.map((card) => ({
      id: card.id,
      cardName: card.name,
      cardImageUrl: card.imageUrl,
      cardTargetUrl: card.targetUrl,
      carouselId: card.carouselId
    }));

    canvasElements.push({
      id: canvasCarousel.id,
      type: 'Carousel',
      name: canvasCarousel.name,
      radioFitCarousel: canvasCarousel.option,
      cards,
      canvasId: canvasCarousel.canvasId,
      order: canvasCarousel.order
    });
  });

  canvas.tiles = [];
  const canvasTiles = canvases.canvasTile.list.filter(
    (tile) => tile.canvasId === id
  );

  canvasTiles.forEach((canvasTile) => {
    canvas.tiles.push({
      id: canvasTile.id,
      name: canvasTile.name,
      asset: canvasTile.asset,
      image_url: canvasTile.imageUrl
    });
  });

  canvas.canvasElements = canvasElements;

  return canvas;
};

export const launchCanvasToFacebook = async (parameters, canvas) => {
  const errorDetails = [];
  const canvasObj = canvas[0];
  const canvasElements = canvas.canvasElements;
  const { enableSwipe, name: canvasName, theme: canvasTheme } = canvasObj;
  const finalEnableSwipe =
    enableSwipe !== null && enableSwipe !== undefined ? enableSwipe : true;

  const sortedElements = _.sortBy([...canvasElements], 'order');

  const elements = await Promise.all(
    sortedElements.map(async (element) => {
      const { type } = element;
      const newElement = element;
      let canvasPhoto;
      let canvasVideo;
      let canvasCarousel;

      switch (type) {
        case 'Photo':
          canvasPhoto = await buildCanvasPhoto(parameters, element);
          if (!canvasPhoto) {
            errorDetails.push(`Error Creating Photo: "${element.name}"`);
          }
          return Promise.resolve(canvasPhoto);
        case 'Video':
          canvasVideo = await buildCanvasVideo(parameters, element);
          if (!canvasVideo) {
            errorDetails.push(`Error Creating Video: "${element.name}"`);
          }
          return Promise.resolve(canvasVideo);
        case 'Carousel':
          newElement.cards = element.cards.map((card) => ({
            id: card.id,
            name: card.cardName,
            url: card.cardImageUrl,
            imageTargetUrl: card.cardTargetUrl,
            carouselId: card.carouselId
          }));
          canvasCarousel = await buildCanvasCarousel(parameters, newElement);
          if (!canvasCarousel) {
            errorDetails.push(`Error Creating Carousel: "${element.name}"`);
          }
          return Promise.resolve(canvasCarousel);
        default:
          return Promise.resolve(null);
      }
    })
  );

  const result = await buildCanvas(
    parameters,
    elements,
    canvasName,
    canvasTheme,
    finalEnableSwipe
  );

  return { result, errorDetails };
};



// WEBPACK FOOTER //
// ./src/screens/Canvas/CanvasLauncher.js